
import { Stack } from '@fluentui/react';
import { FluentProvider, webLightTheme, SkeletonItem } from '@fluentui/react-components';
import { childHome, DynamicBoxingCSS, dashboardTheme, skeleton14, skeleton7, skeleton8 } from '../../styles/customStyles';

export const SkeletonOverlayDataTable = () => {
  return (
    <>
      <FluentProvider style={DynamicBoxingCSS} theme={dashboardTheme}>
        <Stack style={DynamicBoxingCSS} tokens={{ childrenGap: 15 }}>
          <SkeletonItem size={24} style={childHome} />
          <SkeletonItem style={DynamicBoxingCSS} />
        </Stack>
      </FluentProvider>
    </>
  );
};